import { render, staticRenderFns } from "./TemplateFileUploadCheckListCol.vue?vue&type=template&id=be48eb50&scoped=true"
import script from "./TemplateFileUploadCheckListCol.vue?vue&type=script&lang=js"
export * from "./TemplateFileUploadCheckListCol.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be48eb50",
  null
  
)

export default component.exports